<template>
    <Head :title="'Gina Betbeze - St. Johns County Realtor | Julington Creek Homes Expert'" >
        <link rel="canonical" href="https://www.ginabetbeze.com/" />
        <meta
            name="description"
            content="Gina Betbeze, St. Johns County Realtor and Julington Creek homes expert. Discover top real estate services for buying or selling in Jacksonville, FL. Start your journey with a trusted local pro."
        />
    </Head>
    <!-- Simple Blurb -->
    <CallToAction />

    <!-- Section with some Graphic Elements -->
    <CommunityGrid />
    <HomeSearch />
    <HomeBlurb/>
    <Testimonials/>
</template>
<script setup>
import HomeSearch from "../Components/PageContent/HomeSearch.vue";
import CallToAction from "../Components/PageContent/CallToAction.vue";
import CommunityGrid from "../Components/PageContent/CommunityGrid.vue";
import HomeLayout from "../Layouts/HomeLayout.vue";
import HomeBlurb from "../Components/PageContent/HomeBlurb.vue"
import Testimonials from "../Components/PageContent/Testimonials.vue"

import { Head, usePage } from "@inertiajs/vue3";

defineOptions({ layout: HomeLayout });
const page = usePage();
const props = defineProps({
    communities: {
        // This is just the qs data
        type: Object,
        required: false,
    },
});
</script>
